export class RozlaczSrodkiModel {
    idLokalizacji: string;
    idProjektu: string;
    idSpisanegoSrodka: string;
    idSrodkaEwidencji: string;
}